import { Component, OnInit, Input } from '@angular/core';
import { Observable, take } from 'rxjs';

import {
  BanksCalculator,
  EstoCalculatorPeriods,
  LoanPeriods,
  TranslateDirective,
} from '@speedy/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgClass, DecimalPipe } from '@angular/common';

import { CurrencyComponent } from '../../../../../../shared/components/currency/currency.component';
import { CalculatorService } from '../../../services/calculator.service';

@Component({
  selector: 'app-esto-calculator',
  templateUrl: './esto-calculator.component.html',
  styleUrls: ['./esto-calculator.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    TranslateDirective,
    ReactiveFormsModule,
    FormsModule,
    CurrencyComponent,
    MatProgressSpinner,
    DecimalPipe,
  ],
})
export class EstoCalculatorComponent implements OnInit {
  @Input() productPrice!: number;

  loanPeriod!: LoanPeriods;
  loanPeriods!: Array<LoanPeriods>;
  loadingPayment = false;

  monthlyPayment!: number;
  contractFee = 0;
  interest = 0.119;
  managementFee = 1.9;

  constructor(protected calculatorService: CalculatorService) {}

  ngOnInit() {
    this.getPeriods();
  }

  protected getPeriods() {
    (
      this.calculatorService.getPeriodsByBank(
        BanksCalculator.Esto,
        this.productPrice,
      ) as Observable<EstoCalculatorPeriods>
    )
      .pipe(take(1))
      .subscribe((data) => {
        if (data && data.periods) this.loanPeriods = data.periods;
        this.loanPeriod = data.periods[0];
        this.changePeriod(this.loanPeriod);
      });
  }

  public changePeriod(period: LoanPeriods) {
    this.loadingPayment = true;
    this.monthlyPayment =
      this.productPrice / period.period +
      (this.productPrice * this.interest) / 12 +
      this.managementFee;

    this.loadingPayment = false;
  }
}
